import styled from 'styled-components';

const blueArrow = 'https://assets-gos3.goibibo.com/myp_homepage_arrow-1698734649.png';

export const Container = styled.div`
  position: relative;
  &.mobileContainer {
  }
`;

export const Heading = styled.h4`
  font-family: Lato;
  font-style: normal;
  font-weight: 900;
  font-size: 40px;
  line-height: 48px;
  text-align: center;
  color: #000;
  margin-top: 105px;
  padding: 0px 16px;

  &.mobileHeading {
    font-size: 24px;
    line-height: 29px;
    margin-top: 26px;
    text-align: left;
    width: 288px;
  }
`;

export const SubHeading = styled.h2`
  font-family: Lato;
  font-weight: 400;
  font-size: 24px;
  line-height: 36px;
  text-align: center;
  letter-spacing: -1px;
  color: #2f281e;

  &.mobileSubHeading {
    font-family: Lato;
    font-weight: 400;
    font-size: 14px;
    line-height: 20px;
    color: #333333;
    text-align: left;
    padding: 0px 16px;
  }
`;

export const CurveBox = styled.div`
  border-bottom-left-radius: 50% 150px !important;
  border-bottom-right-radius: 50% 150px !important;
  position: relative;
  overflow: hidden;
  width: 160%;
  margin-bottom: -50px;
  left: -30%;
  background-color: #fff;
  background-size: 42% auto;
  height: 432px;

  &.mobileCurve {
    left: unset;
    margin-bottom: -18px;
    border-bottom-left-radius: 150% 56px !important;
    border-bottom-right-radius: 150% 56px !important;
    width: 100%;
    height: 350px;
  }
`;

export const BottomWrapper = styled.div`
  background: #f2f2f2;
  padding-top: 236px;
  padding-left: 247px;
  padding-right: 247px;
  padding-bottom: 40px;
  display: flex;
  justify-content: space-between;
`;

export const VideoContainer = styled.div`
  &.mobileVideoContainer {
    padding: 0px 16px;
  }

  .slick-slider {
    @media only screen and (min-width: 1023px) {
      min-height: 400px;
      max-height: 400px;
    }
  }

  &.center-slider .slick-slide {
    background-color: #b32532;
    color: #fff;
    height: 358px;
    margin: 0 15px 0 0;
    display: flex;
    align-items: center;
    justify-content: center;
    transform: scale(0.7, 0.7);
    transition: transform 0.3s;
  }

  .center-slider .slick-slide,
  .center-slider
    .slick-slide[aria-hidden='true']:not(.slick-cloned)
    ~ .slick-cloned[aria-hidden='true'] {
    transform: scale(0.8, 0.8);
    transition: all 0.4s ease-in-out;
  }

  /* Active center slide (You can change anything here for cenetr slide)*/
  .center-slider .slick-center,
  .center-slider
    .slick-slide[aria-hidden='true']:not([tabindex='-1'])
    + .slick-cloned[aria-hidden='true'] {
    background-color: #000000;
    transform: scale(1, 1);
  }
  .center-slider .slick-current.slick-active {
    transform: scale(1.1);
    background-color: #000000;
  }
  button.slick-arrow {
    width: 44px;
    height: 44px;
    background: #fff;
    border-radius: 50%;
  }

  .slick-next,
  .slick-prev {
    z-index: 5;
    top: 28%;
  }
  .slick-next {
    right: 25px;
  }
  .slick-prev {
    left: 25px;
  }
  button.slick-arrow.slick-prev {
    background: #fff url(${blueArrow}) center center no-repeat;
    transform: translate(0, -50%) rotate(180deg);
    box-shadow: 0px 1px 11px rgba(0, 0, 0, 0.2);
  }
  button.slick-arrow.slick-next {
    background: #fff url(${blueArrow}) center center no-repeat;
    box-shadow: 0px 1px 11px rgba(0, 0, 0, 0.2);
  }
  .slick-next:before,
  .slick-prev:before {
    display: none;
  }
  .slick-dots li button:before {
    font-size: 25px;
    color: #d1c7e2;
  }
  .slick-dots li {
    width: 5px;
    height: 5px;
  }
  .slick-dots li.slick-active button:before {
    opacity: 0.75;
    color: #443963;
  }
  .slick-track {
    padding: 15px 4px 4px 4px;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background: #fff;
  }
  .slick-dots {
    bottom: 0;
    @media only screen and (min-width: 676px) and (max-width: 1023px) {
      bottom: 120px;
    }
  }
  .mobile-slider .slick-track {
    padding: 9px 0px 15px 0px;
  }
  .mobile-slider .slick-dots {
    bottom: -10px;
  }
`;

export const CardContainer = styled.div`
  padding: 6px;
  background: #fff;
  position: relative;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);

  .playIcon {
    position: absolute;
    width: 56px;
    height: 56px;
    left: 44%;
    top: 32%;
    z-index: 99;
  }

  img.playIcon.mobilePlayIcon {
    width: 42px;
    height: 42px;
  }
`;

export const Seperator = styled.div`
  border: 2px solid #008cff;
  width: 25px;
  &.mobileSeperator {
    border: 1px solid #008cff;
  }
`;

export const VideoInfo = styled.div`
  position: absolute;
  bottom: 18px;
  padding: 10px 35px 10px 25px;

  &.mobileVideoInfo {
    bottom: 5px;
    padding: 10px 25px 10px 25px;
  }
`;

export const ReviewInfo = styled.p`
  font-family: Lato;
  font-weight: 600;
  font-size: 16px;
  line-height: 19px;
  color: #cecece;
  margin-bottom: 11px;

  &.mobileReviewInfo {
    font-size: 10px;
    line-height: 12px;
    margin-bottom: 6px;
  }
`;

export const ReviewerName = styled.p`
  font-family: Lato;
  font-size: 20px;
  line-height: 24px;
  color: #ffffff;
  margin-top: 6px;

  &.mobileReviewerName {
    margin-top: 6px;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const ReviewrCompany = styled.span`
  font-family: Lato;
  font-weight: 600;
  font-size: 20px;
  color: #ffffff;

  &.mobileReviewerCompany {
    margin-top: 6px;
    font-size: 12px;
    line-height: 14px;
  }
`;

export const CardWrapper = styled.div`
  width: 100%;
  height: 100%;
  background: #a97878;
`;

export const LeftCard = styled.div`
  padding-top: 36px;
  width: 580px;
  background: #fff;
  box-shadow: 0px 2px 16px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
`;

export const BlockQuote = styled.div`
  &.mobileBlockQuote {
    background: #fff;
  }
`;

export const Bloque = styled.span`
  font-size: 60px;
  line-height: 61px;
  display: inline-block;
  font-family: Abril Fatface;
  color: #ff664b;

  &.mobileBloque {
    font-size: 48px;
    line-height: 45px;
  }
`;

export const BlockWrapper = styled.div`
  padding-left: 60px;
  padding-right: 60px;
  position: relative;

  &.mobileBlockWrapper {
    padding: 20px;
    background: #fff;
    margin-top: 20px;
    min-height: 375px;
  }
`;

export const BlockTitle = styled.p`
  font-family: Lato;
  font-style: normal;
  font-weight: 700;
  font-size: 28px;
  line-height: 34px;

  &.mobileBlockTitle {
    font-size: 21px;
    line-height: 25px;
  }
`;

export const BlockDescp = styled.p`
  margin-top: 18px;
  font-family: Lato;
  font-style: normal;
  font-weight: 400;
  font-size: 16px;
  line-height: 19px;
  color: #575656;

  &.mobileBlockDescp {
    font-size: 12px;
    line-height: 14px;
  }
`;

export const Marker = styled.div`
  margin-top: 30px;
  border: 2px solid #ff664b;
  width: 39px;
  margin-bottom: 21px;
`;

export const Credential = styled.p`
  font-family: Lato;
  font-weight: 900;
  font-size: 14px;
  line-height: 17px;
  color: #a96f6f;

  &.mobileCredential {
    font-size: 12px;
    line-height: 14px;
  }
`;

export const Footer = styled.div`
  margin-top: 43px;
  border-top: 1.5px solid #eeeeee;
  display: flex;
  justify-content: space-between;
  padding: 21px 0px;
  padding-left: 60px;
  padding-right: 60px;

  &.mobileFooter {
    padding: 20px;
    background: #fff;
    margin-top: 2px;
  }
`;

export const Div = styled.div`
  &.mobileCol {
    display: flex;
    flex-direction: column;
  }
`;

export const CompanyDetail = styled.span`
  font-family: Lato;
  font-weight: 400;
  font-size: 11px;
  line-height: 13px;
  color: #a96f6f;

  &.mobileCompanyDetail {
    font-size: 11px;
    line-height: 13px;
    margin-bottom: 4px;
    color: #959292;
  }
`;

export const CompanyInfo = styled.span`
  font-family: Lato;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  color: #a96f6f;

  &.mobileCompanyInfo {
    font-size: 11px;
    line-height: 13px;
    color: #7c7c7c;
  }
`;

export const RightCard = styled.div`
  font-family: Lato;
  font-weight: 700;
  font-size: 11px;
  line-height: 13px;
  color: #a96f6f;
  width: 429px;
`;

export const CardTitle = styled.h1`
  font-family: Lato;
  font-weight: 900;
  font-size: 40px;
  line-height: 48px;
  color: #000000;
`;

export const ReviewContainer = styled.ul`
  margin-top: 30px;
  width: 378px;
  border-left: 1px solid #d6d6d6;
`;

export const ReviewItem = styled.li`
  font-family: Lato;
  font-weight: 900;
  font-size: 16px;
  line-height: 19px;
  color: #f76162;
  padding: 16px;
  cursor: pointer;

  &.active {
    background: #ffe8e8;
    border-left: 5px solid #f76162;
  }

  &.mobileContainer {
    padding-right: 4px;
  }

  &.active.mobileContainer {
    border-left: unset;
    border-bottom: 3px solid #f76162;
    padding-right: 4px;
  }
`;

export const MobileBottomWrapper = styled.div`
  padding: 16px;
  background: #f2f2f2;
`;

export const BusinessTitle = styled.h1`
  font-family: Lato;
  font-weight: 900;
  font-size: 24px;
  line-height: 29px;
  text-transform: capitalize;
  color: #3b385e;
  padding-top: 75px;
  padding-bottom: 24px;
`;

export const MyBizText = styled.span`
  color: #f76162;
`;

export const MobileReviewContainer = styled.div`
  display: flex;
  width: 100%;

  .slick-slider.business-slider {
    width: 100%;
  }

  .slick-slider.business-slider.slick-initialized {
    padding-right: 20px;
  }
`;

export const MobileReviewList = styled.li``;

export const MobileCardWrapper = styled.div`
  margin-top: 10px;
  .slick-initialized .slick-slide {
    padding-right: 20px;
  }
`;
